import * as i0 from '@angular/core';
import * as i1 from './hint.module';
import * as i2 from './hint.directive';
export const BllHintModuleNgFactory:i0.NgModuleFactory<i1.BllHintModule> = (null as any);
var _decl0_0:i2.BllHintDirective = (<any>(null as any));
var _decl0_1:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_2:i0.ElementRef<any> = (<any>(null as any));
